import { render, staticRenderFns } from "./ec-buffer.vue?vue&type=template&id=66f1579e&scoped=true&"
import script from "./ec-buffer.vue?vue&type=script&lang=js&"
export * from "./ec-buffer.vue?vue&type=script&lang=js&"
import style0 from "./ec-buffer.vue?vue&type=style&index=0&id=66f1579e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f1579e",
  null
  
)

/* custom blocks */
import block0 from "./ec-buffer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports